import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ContentBox from './ContentBox';
import { useInStaffPanel } from './staff/StaffPanelContext';
import StaffSectionLayout from './staff/StaffSectionLayout';

function GeneralLayout({ children, userData }) {
    const inStaffPanel = useInStaffPanel();

    const location = useLocation();
    const activeUrl = location.pathname;

    const navLinks = [
        { path: '/staff/general/award-stamps', label: 'Award Framps', requiresStaff: true },
        { path: '/staff/general/award-achievements', label: 'Award Achievements', requiresStaff: true },
        { path: '/staff/general/appreciation', label: 'I Appreciate You', requiresStaff: true },
    ];

    const visibleLinks = navLinks.filter(link => {
        if (link.requiresAdmin) return userData?.hasAdminRole === true;
        if (link.requiresStaff) return userData?.hasStaffRole === true;
        return true;
    });

    if (inStaffPanel) return <StaffSectionLayout>{children}</StaffSectionLayout>;

    return (
        <div className="w-full min-h-screen p-4 lg:p-6">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
                <div className="lg:col-span-4">
                    <ContentBox theme="default" tint="lightskyblue" header="General">
                        <div className="flex flex-col gap-2">
                            {visibleLinks.map((link, index) => {
                                const isActive = activeUrl === link.path;
                                return (
                                    <Link
                                        key={index}
                                        to={link.path}
                                        className={`font-['Jersey_10'] uppercase text-[16px] tracking-[1px] px-3 py-2 rounded transition-all
                                            ${isActive
                                            ? 'bg-maroon text-white'
                                            : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                                        }`}
                                        style={{ boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.2)' }}
                                    >
                                        {link.label}
                                    </Link>
                                );
                            })}
                        </div>
                    </ContentBox>
                </div>

                <div className="lg:col-span-8">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default GeneralLayout;